import { useQuery } from '@tanstack/react-query'
import { Sponsor } from 'utils/types/sponsor.type'
import { client } from './api-client'

export const useGetAllSponsors = () =>
  useQuery<Sponsor[], Error>(['getAllSponsors'], () =>
    client(`sponsor/getAllSponsors`),
  )
